import dayjs from 'dayjs';
import moment from 'moment';
import { generateValidity } from 'src/utils/helper';
import relativeTime from 'dayjs/plugin/relativeTime';

interface Props {
	isPositionClosed: boolean;
	hasExpiryDate: boolean;
	postedOn: Date;
	expiresOn?: Date;
	updatedAt: Date;
	smallText?: boolean;
}

const ValidityLine = ({ isPositionClosed, hasExpiryDate, postedOn, expiresOn, updatedAt, smallText }: Props) => {
	const currentTime = moment();
	dayjs.extend(relativeTime);
	const targetPostedOnTime = moment(postedOn).format();
	const targetExpiresOnTime = moment(expiresOn);
	const targetExpiresOnUpdatedAt = moment(updatedAt).format();

	const postedOnDiff = moment.duration(currentTime.diff(targetPostedOnTime));
	const expiresOnDiff = moment.duration(targetExpiresOnTime.diff(currentTime));
	const expiredOnDiff = moment.duration(currentTime.diff(targetExpiresOnTime));
	const expiredOnDiffUpdatedAt = moment.duration(currentTime.diff(targetExpiresOnUpdatedAt));

	return hasExpiryDate ? (
		<div
			style={{
				fontSize: smallText ? '12px' : '',
			}}
			className="mt-[6px] hidden font-normal text-[#05A660] dark:text-[#A9EFF2] md:flex items-center"
		>
			<span className="inline-block align-bottom mr-1">
				<img className="" loading="lazy" src="/assets/validForClock.svg" alt="validForClock" width="16" height="16" />
			</span>
			{isPositionClosed || dayjs().isAfter(expiresOn) ? 'Expired' : 'Expires'} at{' '}
			{dayjs(expiresOn).format('DD MMM, YYYY hh:mm A')}
		</div>
	) : updatedAt ? (
		<div
			style={{
				fontSize: smallText ? '12px' : '',
			}}
			className="mt-[6px] hidden font-normal text-[#05A660] dark:text-[#A9EFF2] md:flex items-center"
		>
			<span className="inline-block align-bottom mr-1">
				<img className="" loading="lazy" src="/assets/validForClock.svg" alt="validForClock" width="16" height="16" />
			</span>
			{dayjs().isAfter(updatedAt) ? 'Expired' : 'Expires'} at {dayjs(updatedAt).format('DD MMM, YYYY hh:mm A')}
		</div>
	) : (
		<div
			style={{
				fontSize: smallText ? '12px' : '',
			}}
			className="mt-[6px] hidden font-normal text-[#05A660] dark:text-[#A9EFF2] md:flex items-center"
		>
			<span className="inline-block align-bottom mr-1">
				<img className="" loading="lazy" src="/assets/validForClock.svg" alt="validForClock" width="16" height="16" />
			</span>
			Expired
		</div>
	);

	// if (isPositionClosed) {
	// 	if (hasExpiryDate) {
	// 		return (
	// 			<div
	// 				style={{
	// 					fontSize: smallText ? '12px' : '',
	// 				}}
	// 				className="mt-[6px] hidden font-normal text-[#05A660] dark:text-[#A9EFF2] md:block"
	// 			>
	// 				Expired {generateValidity(expiredOnDiff, 'expired')}
	// 			</div>
	// 		);
	// 	} else {
	// 		if (updatedAt) {
	// 			return (
	// 				<div
	// 					style={{
	// 						fontSize: smallText ? '12px' : '',
	// 					}}
	// 					className="mt-[6px] hidden font-norma text-[#05A660] dark:text-[#A9EFF2] md:block"
	// 				>
	// 					Expired {generateValidity(expiredOnDiffUpdatedAt, 'expired')}
	// 				</div>
	// 			);
	// 		} else {
	// 			return (
	// 				<div
	// 					style={{
	// 						fontSize: smallText ? '12px' : '',
	// 					}}
	// 					className="mt-[6px] hidden font-normal text-[#05A660] dark:text-[#A9EFF2] md:block"
	// 				>
	// 					Expired
	// 				</div>
	// 			);
	// 		}
	// 	}
	// } else {
	// 	if (hasExpiryDate) {
	// 		return (
	// 			<div
	// 				style={{
	// 					fontSize: smallText ? '12px' : '',
	// 				}}
	// 				className="mt-[6px] hidden font-norma text-[#05A660] dark:text-[#A9EFF2] md:block"
	// 			>
	// 				Valid for {generateValidity(expiresOnDiff, 'validFor')}{' '}
	// 				<span className="inline-block align-bottom">
	// 					<img
	// 						className=""
	// 						loading="lazy"
	// 						src="/assets/validForClock.svg"
	// 						alt="validForClock"
	// 						width="16"
	// 						height="16"
	// 					/>
	// 				</span>
	// 			</div>
	// 		);
	// 	} else {
	// 		return (
	// 			<div
	// 				style={{
	// 					fontSize: smallText ? '12px' : '',
	// 				}}
	// 				className="mt-[6px] hidden font-normal text-[#05A660] dark:text-[#A9EFF2] md:block"
	// 			>
	// 				Posted {generateValidity(postedOnDiff, 'postedOn')}
	// 			</div>
	// 		);
	// 	}
	// }
};

export default ValidityLine;
